import React, { useEffect, useState } from "react";
import { Modal, Typography, Alert } from "antd";
import { WarningOutlined, ExclamationCircleOutlined } from "@ant-design/icons";

const { Title, Paragraph, Text } = Typography;

const LoginWarningModal: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const hasShownWarning = sessionStorage.getItem("incentive_warning_shown");
    if (!hasShownWarning) {
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    sessionStorage.setItem("incentive_warning_shown", "true");
  };

  return (
    <Modal
      open={isVisible}
      onOk={handleClose}
      onCancel={handleClose}
      okText="Ойлголоо"
      cancelButtonProps={{ style: { display: "none" } }}
      width={600}
      centered
      closable={false}
      maskClosable={false}
      bodyStyle={{
        padding: "24px",
      }}
    >
      <div style={{ textAlign: "center", marginBottom: 24 }}>
        <ExclamationCircleOutlined style={{ fontSize: 64, color: "#faad14" }} />
        <Title
          level={3}
          style={{ marginTop: 16, marginBottom: 0, color: "#d48806" }}
        >
          Анхааруулга
        </Title>
      </div>

      <Alert
        type="warning"
        showIcon={false}
        style={{
          backgroundColor: "#fffbe6",
          border: "1px solid #ffe58f",
          borderRadius: 8,
          marginBottom: 16,
        }}
        description={
          <div style={{ fontSize: 15, lineHeight: 1.8 }}>
            <Paragraph style={{ marginBottom: 16 }}>
              <Text strong>Урамшууллын хүсэлт илгээхдээ:</Text>
            </Paragraph>
            <ul style={{ paddingLeft: 20, marginBottom: 16 }}>
              <li>Хуурамч баримт, мэдээлэл бүрдүүлэх</li>
              <li>
                Зах зээлийн бөөний үнээс үндэслэлгүйгээр хэт бага үнээр
                борлуулсан мэтээр тусгах
              </li>
              <li>И-баримтыг хуурамчаар шивэх</li>
            </ul>
            <Paragraph style={{ marginBottom: 16 }}>
              зэрэг{" "}
              <Text strong style={{ color: "#cf1322" }}>
                зөрчил гаргасан тохиолдолд урамшуулал олгохгүй.
              </Text>
            </Paragraph>
            <Paragraph style={{ marginBottom: 0 }}>
              <WarningOutlined style={{ color: "#cf1322", marginRight: 8 }} />
              <Text strong>
                Ийм төрлийн зөрчлийг холбогдох хууль, журмын дагуу хууль,
                хяналтын байгууллага шалгаж хариуцлага хүлээлгэх болохыг
                анхаарна уу.
              </Text>
            </Paragraph>
          </div>
        }
      />
    </Modal>
  );
};

export default LoginWarningModal;
